export default __webpack_public_path__ + "static/media/googlePng.e12914ad.png";